import businessService from '@/services/business';
import services from '../../services';
import { batchMove, getAllContent } from '../../services/urlConfig';

export const DefaultColumnKey = 'defaultColumnKey';
export const CanCreateColumn = 4;

export function changeAddIrcStatus(checkFolderList, checkFileList, checkIrcList) {
  // 只选择了视频文件类型就显示添加字幕
  if (!checkFolderList.length && checkFileList.length && !checkIrcList.length) {
    return true;
  }
  return false;
}
// 接口返回的文件类型
export const fileTypeConfig = {
  article: 'article', // 音频
  lyric: 'lyric', // 字幕
};
export function getAllArticleAndTextFileList(params, inter = {}) {
  return services[getAllContent.type](getAllContent.url, params, inter);
}

// 删除单曲 promise
export const deleteSubtitleBatch = articleKey => {
  const deletePromise = new Promise(resolve => {
    businessService
      .articleUpdateStatus({
        articleKey,
        status: 3,
      })
      .then(res => {
        resolve(res);
      })
      .catch(e => {
        resolve(e);
      });
  });
  return deletePromise;
};
//  // 删除文件 promise
export const deleteFolderBatch = columnKey => {
  const deletePromise = new Promise(resolve => {
    businessService
      .updateStatus({
        columnKey,
        status: 2,
      })
      .then(res => {
        resolve(res);
      })
      .catch(e => {
        resolve(e);
      });
  });
  return deletePromise;
};
export function deleteIrcBatch(item) {
  const deletePromise = new Promise(resolve => {
    businessService
      .deleteLrc({
        articleKey: item.articleKey,
        columnKey: item.columnKey,
      })
      .then(res => {
        resolve(res);
      })
      .catch(e => {
        resolve(e);
      });
  });
  return deletePromise;
}

// 音频是否含有字幕文件
export function hasLyric(data = {}) {
  return Number(data.lrcStatus) === 1;
}
// 音频是否是空文件夹
export function isNullFolder(data = {}) {
  return !data.fileCount || data.fileCount === 0;
}
export function batchMoveFile(params) {
  return services[batchMove.type](batchMove.url, params);
}
